export default "__VITE_ASSET__B3Pren$9__"